import { getSecrets } from "../config";
import { ethers } from "ethers";

import { RoomInitializationError } from "../errors";

export const hashCode = (url: string) => {
  let hash = 0;
  let i;
  let chr;
  if (url.length === 0) return "0" + hash;
  for (i = 0; i < url.length; i++) {
    chr = url.charCodeAt(i);
    hash = (hash << 5) - hash + chr;
    hash |= 0; // Convert to 32bit integer
  }
  return "0" + hash;
};

export const combineWWWPrefix = (url: string) => {
  var match = url.match(/(.+):\/\/(www[0-9]?\.)?(.+)/i);
  if (
    match != null &&
    match.length > 3 &&
    typeof match[3] === "string" &&
    match[3].length > 0
  ) {
    return match[1] + "://" + match[3];
  }
  throw RoomInitializationError.invalidUrl("The url cannot be parsed");
};

export const removeWWWPrefix = (url: string): string => {
  const match = url.match(/^(https?:\/\/)?(www\.)?(.*)$/i);
  if (match && match[3]) {
    return (match[1] || "") + match[3];
  }
  return url;
};

export const parseUrl = (urlString: string) => {
  let URLSrc = "";
  if (urlString.includes("https://www.youtube.com/watch")) {
    URLSrc = "YouTube";
  }

  switch (URLSrc) {
    case "YouTube":
      const readURL = new URL(urlString);
      const videoID = readURL.searchParams.get("v");
      return `https://www.youtube.com/watch?v=${videoID}`;

    default:
      try {
        const url = new URL(urlString);
        let parsedUrl = url.protocol + "//" + url.hostname;

        if (url.port) {
          parsedUrl += ":" + url.port; // Include the port
        }

        if (url.pathname !== "/") {
          parsedUrl += url.pathname.replace(/\/$/, ""); // Remove trailing slash
        } else if (url.hostname) {
          parsedUrl += "/";
        }

        return parsedUrl;
      } catch (error) {
        throw RoomInitializationError.invalidUrl("The url cannot be parsed");
      }
  }
};

const assetUrlCode = "::protico===assetUrl===protico::";
const listDataCode = "::protico===listData===protico::";
const seperateCode = "::protico===seperate===protico::";
const urlRegex =
  /(?:https?):\/\/(\w+:?\w*)?(\S+)(:\d+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/;
export const encodeAssetUrl = (url: string) => `${assetUrlCode}${url}`;
export const encodeSeperateCode = (url: string, messageText: string) => `${url}${seperateCode}${messageText}`;
export const decodeAssetUrl = (url: string) => {
  let messageText = url.split(seperateCode)[1];
  url = url.split(seperateCode)[0];
  url = url.replace(assetUrlCode, "");
  url = url.replace(listDataCode, "");
  if (url.includes("data:image/svg+xml;base64")) {
    return [url.split(",")[0] + "," + url.split(",")[1], url.split(",")[2], messageText];
  } else if (url.includes("data:image/png;base64")) {
    return [url.split(",")[0] + "," + url.split(",")[1], url.split(",")[2], messageText];
  } else {
    return [url.split(",")[0], url.split(",")[1], messageText];
  }
};
export const decodeAssetData = (url: string) => {
  url = url.replace(assetUrlCode, "");
  url = url.replace(listDataCode, "");
  return url;
};
export const isAssetUrl = (url: string) =>
  url?.includes(assetUrlCode) &&
  !url?.includes(listDataCode) &&
  urlRegex.test(url);

export const encodeListUrl = (url: string, price: string) =>
  `${assetUrlCode}${url}${listDataCode}`;
export const decodeListUrl = (url: string) => {
  url = url.substring(listDataCode.length, url.indexOf(listDataCode));
  return url;
};
export const decodeListPrice = (price: number, currency: any) => {
  const {
    USDC_CONTRACT,
    ETH_CONTRACT,
    USDT_CONTRACT,
    MATIC_CONTRACT,
    ETH_CONTRACT_MATIC,
    USDC_CONTRACT_MATIC,
    USDT_CONTRACT_MATIC,
  } = getSecrets();
  if (price != null) {
    if (currency == USDC_CONTRACT) {
      return ethers.utils
        .formatUnits(
          ethers.BigNumber.from(
            price.toLocaleString("fullwide", { useGrouping: false })
          ),
          6
        )
        .toString();
    } else if (
      currency == ETH_CONTRACT ||
      currency == USDT_CONTRACT ||
      currency == MATIC_CONTRACT ||
      currency == ETH_CONTRACT_MATIC ||
      currency == USDC_CONTRACT_MATIC ||
      currency == USDT_CONTRACT_MATIC
    ) {
      return ethers.utils
        .formatEther(
          ethers.BigNumber.from(
            price.toLocaleString("fullwide", { useGrouping: false })
          )
        )
        .toString();
    }
  } else {
    return 0;
  }
};
export const decodeListAvailable = (
  available: boolean,
  item_status: number
) => {
  //0 可購買, 1 已購買, 2 已下架
  if (available != null) {
    if (available) return 0;
    if (!available && item_status == 1) return 1;
    return 2;
  } else {
    return 2;
  }
};
export const isListUrl = (url: string) =>
  url?.includes(assetUrlCode) &&
  url?.includes(listDataCode) &&
  urlRegex.test(url);

export const decodeCurrency = (address: string, chain_id: any) => {
  const {
    USDC_CONTRACT,
    ETH_CONTRACT,
    USDT_CONTRACT,
    MATIC_CONTRACT,
    ETH_CONTRACT_MATIC,
    USDC_CONTRACT_MATIC,
    USDT_CONTRACT_MATIC,
  } = getSecrets();
  if (chain_id == 137 && address == MATIC_CONTRACT) return "MATIC";
  if (chain_id == 137 && address == ETH_CONTRACT_MATIC) return "ETH";
  if (chain_id == 137 && address == USDC_CONTRACT_MATIC) return "USDC";
  if (chain_id == 137 && address == USDT_CONTRACT_MATIC) return "USDT";
  if (address == ETH_CONTRACT) return "ETH";
  if (address == USDT_CONTRACT) return "USDT";
  if (address == USDC_CONTRACT) return "USDC";
};
export const getRandomString = (length: number = 5) => {
  let result = "";
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  const charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};
export const getAddressFromCaip10Link = (caip10Link: string) => {
  return caip10Link.slice(16);
};

/**
 * check if this is a correct address format
 */
export const checkAddress = (address: string) => {
  const rExp: RegExp = /^0x[a-fA-F0-9]{40}$/;
  if (!rExp.test(address)) throw new Error("Address is not correct");
  return address;
};

/**
 * check if this is an ENS
 */
export const checkENS = (ens: string) => ens.endsWith(".eth");

export const checkPin = (pin: string) => {
  if (!pin) return false;
  if (pin.length < 6) throw new Error("PIN_Signup_Invalid_Length");
  const rExp: RegExp = /^[A-Za-z0-9_\-/#^%@()+!.*\[\]&'",:;=?$]+$/;
  if (!rExp.test(pin)) throw new Error("PIN_Signup_Invalid_Format");
  return true;
};

export const ISOStringFromDate = (date: Date) => {
  return date.toISOString().replace("T", " ").slice(0, 19) + " UTC";
};

export const truncateUsername = (
  s: string | undefined,
  maxLength: number = 15
): string => {
  if (s === undefined) return "Guest";

  if (s.length <= maxLength) return s;

  return s.slice(0, maxLength) + "...";
};

export function notEmpty<TValue>(
  value: TValue | null | undefined
): value is TValue {
  return value !== null && value !== undefined;
}

export const cutURL = (str: string) => {
  if (!str) return "";
  if (str.length <= 20) return "(" + str + ")";
  return "(" + str.slice(0, 15) + "..." + str.slice(-5) + ")";
};

export const decodeImageSrc = (src: string) => {
  return src;
};

// Utility function to extract the domain from a URL or a simple domain string
export function extractDomain(url: string) {
  try {
    const hostname = new URL(url).hostname;
    return hostname.replace("www.", "");
  } catch (e) {
    return null;
  }
}
export function extractURL(text: string): string | null {
  const urlRegex = /https?:\/\/[^\s]+/g;
  const match = text.match(urlRegex);
  return match ? match[0] : null;
}

export function isUrl(url: string) {
  return urlRegex.test(url);
}
export function getImgproxyUrl(
  originalUrl: string,
  width = 256,
  height = 256,
  format = "webp"
) {
  if (!originalUrl.includes("https://assets.protico.io")) {
    return originalUrl; // 回傳原本的 URL
  }

  const { IMGPROXY_BASE_URL } = getSecrets();
  const relativePath = originalUrl.replace("https://assets.protico.io", "");
  return `${IMGPROXY_BASE_URL}/${width}x${height}/${format}${relativePath}`;
}

/**
 * Strip out markdown‐style mention links like @[Name](...) and turn them into plain @Name mentions.
 *
 * @example
 * stripMentionLinks("@ … @ xxx")
 * // returns "@愛因斯坦 … @牛頓 xxx"
 */
export function stripMentionLinks(text: string): string {
  // Match @\[displayName\]\(anything but )\) and replace with @displayName
  return text.replace(/@\[(.*?)\]\([^)]*\)/g, '@$1');
}
/**
 * Strip out custom __CMD__…__CMD__ markers, leaving only the inner text.
 *
 * @example
 * stripCmdMarkers("Hello __CMD__world__CMD__!") 
 * // returns "Hello world!"
 *
 * @param text - The input string possibly containing __CMD__ markers
 * @returns A new string with all __CMD__ markers removed
 */
export function stripCmdMarkers(text: string): string {
  // Use [\s\S] to match any character including newlines, non-greedy
  return text.replace(/__CMD__([\s\S]*?)__CMD__/g, '$1');
}
